import axiosInstance from './axiosInstance';

// Authentication API functions
export const authApi = {

  // Username/Password Login
  emaillogin: async (credentials) => {
    
    try {
      const response = await axiosInstance.post('/Corrohealth/auth/login', {
        email: credentials.username,
        password: credentials.password
      });

      

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Send OTP to mobile number
  sendOtp: async (phoneNumber) => {
    try {
      const response = await axiosInstance.post(`/Corrohealth/auth/send-otp?phoneNumber=${phoneNumber}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify OTP
  verifyOtp: async (phoneNumber, otp) => {
    try {
      const response = await axiosInstance.post(`/Corrohealth/auth/verify-otp?phoneNumber=${phoneNumber}&otp=${otp}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  isApprovedByAdmin:async(email)=>{
    try {
      const response=await axiosInstance.get(`Corrohealth/public/gatemen/approval-status?email=${email}`)
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Send OTP to email for conference room login
  sendEmailOtp: async (email) => {
    try {
      const encodedEmail = encodeURIComponent(email.trim());
      const response = await axiosInstance.post(`/Corrohealth/auth/send-email-otp?email=${encodedEmail}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify email OTP for conference room login
  verifyEmailOtp: async (email, otp) => {
    try {
      const encodedEmail = encodeURIComponent(email.trim());
      const encodedOtp = encodeURIComponent(otp.trim());
      const response = await axiosInstance.post(`/Corrohealth/auth/verify-email-otp?email=${encodedEmail}&otp=${encodedOtp}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get OTP for development/testing (only works when dev-mode is enabled)
  getDevOtp: async (identifier) => {
    try {
      const encodedIdentifier = encodeURIComponent(identifier.trim());
      const response = await axiosInstance.get(`/Corrohealth/dev/otp?identifier=${encodedIdentifier}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Refresh access token using refresh token
  refreshToken: async (refreshToken) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/auth/refresh', {
        refreshToken: refreshToken
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Logout - revoke refresh token
  logout: async (refreshToken) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/auth/logout', {
        refreshToken: refreshToken
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}



export default authApi;
